import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VerifyEmailComponent } from './verify-email.component';
import { PasswordvalidationComponent } from '../upload-required-documents/passwordvalidation/passwordvalidation.component';
import { UploadRequiredDocumentsComponent } from '../upload-required-documents/uploadrequireddocuments/uploadrequireddocuments.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: 'verifyemail', component: VerifyEmailComponent },
  { path: 'verifyemail/:id', component: VerifyEmailComponent },
  { path: 'passwordValidation', component: PasswordvalidationComponent },
  { path: 'passwordValidation/:id', component: PasswordvalidationComponent },
  {
    path: 'uploadDocuments/:id',
    component: UploadRequiredDocumentsComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VerifyEmailRoutingModule { }
